<template>
  <div class="c-please-login">
    <p class="text">請先登入會員</p>
    <div class="btn-wrap">
      <pr-button @click="closeDialog" width="400">確認</pr-button>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import PrButton from '@/components/Global/PrButton.vue';

export default defineComponent({
  name: 'PleaseLogin',
  components: {
    PrButton,
  },
  emits: ['closeDialog'],
  setup(props, { emit }) {
    const router = useRouter();

    const closeDialog = () => {
      router.push({ name: 'login' });
      emit('closeDialog', 'pleaseLogin');
    };

    return {
      closeDialog,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-please-login {
  @include padding(50px 75px);
  @include flex(center, center, column);
}
.text {
  @include font-normal();
}

.btn-wrap {
  margin-top: 50px;
}
</style>
